import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';

import './Contatti.css';

class Contatti extends Component {

    render() {
        return (
            <Grid item xs={12} id='contacts'>
                <Grid container>
                    <Grid item xs={12}><h1 className='slide-title'>Contatti</h1></Grid>
                    <Grid item xs={12} md={6}>
                        <table id='table-time'>
                            <thead>
                                <tr>
                                    <th colSpan='2'>Orario</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Lunedì</td>
                                    <td className='td-time'>10:00 - 19:00 </td>
                                </tr>
                                <tr>
                                    <td>Martedì</td>
                                    <td className='td-time'>10:00 - 19:00 </td>
                                </tr>
                                <tr>
                                    <td>Mercoledì</td>
                                    <td className='td-time'>10:00 - 19:00 </td>
                                </tr>
                                <tr>
                                    <td>Giovedì</td>
                                    <td className='td-time'>10:00 - 19:00 </td>
                                </tr>
                                <tr>
                                    <td>Venerdì</td>
                                    <td className='td-time'>10:00 - 19:00 </td>
                                </tr>
                                <tr>
                                    <td>Sabato</td>
                                    <td className='td-time'>CHIUSO</td>
                                </tr>
                                <tr>
                                    <td>Domenica</td>
                                    <td className='td-time'>CHIUSO</td>
                                </tr>
                            </tbody>
                        </table>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <table id='table-address'>
                            <thead>
                                <tr>
                                    <th className='extra-padding'>Radio Gaga Srl</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr><td>Via Tripolitania, 191-193</td></tr>
                                <tr><td className='extra-padding'>00199 ROMA</td></tr>
                                <tr><td>Tel. +39 06 86211624 </td></tr>
                                <tr><td className='extra-padding'>Fax. +39 06 86201723</td></tr>
                                <tr><td><a href='mailto:accettazione@radiogaga.it'>accettazione@radiogaga.it</a></td></tr>
                            </tbody>
                        </table>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default Contatti;